<template>
  <div>
    <b-modal
      hide-footer
      hide-backdrop
      no-close-on-esc
      title="Settings"
      ref="posSettingsModal"
      id="posSettingsModal"
      size="sm"
    >
      <div class="row settings-box mb-4" v-if="USE_TIM_INTEGRATION == 'Y'">
        <div class="col-12 setting-head text-blue border-bottom mb-2 pb-2">
          {{ "ECR Settings" }}
        </div>
        <div class="col-12 py-2">
          <div class="row">
            <div class="col-4 d-flex align-items-center fs-11">POS ID:</div>
            <div class="col-8">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="pos_settings.ECR_SETTINGS.pos_id"
                    type="text"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 py-2">
          <div class="row">
            <div class="col-4 d-flex align-items-center fs-11">IP Address:</div>
            <div class="col-8">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="pos_settings.ECR_SETTINGS.ecr_ip_address"
                    type="text"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 py-2">
          <div class="row">
            <div class="col-4 d-flex align-items-center fs-11">PORT:</div>
            <div class="col-8">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="pos_settings.ECR_SETTINGS.ecr_port"
                    type="text"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row settings-box mb-4"
        v-if="USE_PLAY_ALHAMRA_CARD_MACHINE == 'Y'"
      >
        <div class="col-12 setting-head text-blue border-bottom mb-2 pb-2">
          {{ "ECR Settings" }}
        </div>
        <div class="col-12 py-2">
          <div class="row">
            <div class="col-4 d-flex align-items-center fs-11">POS ID:</div>
            <div class="col-8">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="pos_settings.ECR_SETTINGS.pos_id"
                    type="text"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 py-2">
          <div class="row">
            <div class="col-4 d-flex align-items-center fs-11">ECR NO:</div>
            <div class="col-8">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="pos_settings.ECR_SETTINGS.ecr_no"
                    type="text"
                    minlength="2"
                    maxlength="2"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 py-2">
          <div class="row">
            <div class="col-4 d-flex align-items-center fs-11">IP Address:</div>
            <div class="col-8">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="pos_settings.ECR_SETTINGS.ecr_ip_address"
                    type="text"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 py-2">
          <div class="row">
            <div class="col-4 d-flex align-items-center fs-11">PORT:</div>
            <div class="col-8">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="pos_settings.ECR_SETTINGS.ecr_port"
                    type="text"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row settings-box mb-4"
        v-if="USE_EPIX_ASF_CARD_MACHINE == 'Y'"
      >
        <div class="col-12 setting-head text-blue border-bottom mb-2 pb-2">
          {{ "ECR Settings" }}
        </div>
        <div class="col-12 py-2">
          <div class="row">
            <div class="col-4 d-flex align-items-center fs-11">MID:</div>
            <div class="col-8">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="pos_settings.ECR_SETTINGS.mid"
                    type="text"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 py-2">
          <div class="row">
            <div class="col-4 d-flex align-items-center fs-11">TID:</div>
            <div class="col-8">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="pos_settings.ECR_SETTINGS.tid"
                    type="text"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row settings-box" v-else>
        <div
          class="noSettings d-flex align-items-center justify-content-center w-100"
        >
          No Settings Found
        </div>
      </div>

      <div class="row">
        <div class="col-12 pt-3 text-center">
          <button
            v-on:click="saveSettings()"
            v-if="USE_TIM_INTEGRATION == 'Y'"
            class="btn-blue"
          >
            Save
          </button>
          <button
            v-on:click="saveSettingsV2()"
            v-if="USE_PLAY_ALHAMRA_CARD_MACHINE == 'Y'"
            class="btn-blue"
          >
            Save
          </button>
          <button
            v-on:click="saveSettingsV3()"
            v-if="USE_EPIX_ASF_CARD_MACHINE == 'Y'"
            class="btn-blue"
          >
            Save
          </button>
          <button
            @click.prevent.stop="$bvModal.hide('posSettingsModal')"
            class="btn-blue"
          >
            Cancel
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import { EventBus } from "@/main.js";
import { Role, CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";

export default {
  props: {},
  components: {
    Vkeyboard,
    VkeyboardFloat
  },
  data() {
    return {
      noAuth: false,
      pos_settings: {
        ECR_SETTINGS: {
          pos_id: "ECR-01",
          ecr_no: "",
          ecr_user_id: null,
          ecr_ip_address: "",
          ecr_port: "80",
          ecr_integralId: "367fcd48-f574-4119-960c-d1ebb00f9a97",
          mid: null,
          tid: null
        },
        POS_LOCATION_SETTINGS: {
          selectedLocation: "",
          hardware_location_id: null
        }
      },
      DeviceUniqueCode: null,
      hardware_id: null,
      HardwareLocations: [],
      keyboardsVisible: {
        showFirstNameKeyboard: false,
        showLastNameKeyboard: false,
        showEmailKeyboard: false
      }
    };
  },
  sockets: {
    hardwareId: function(macId) {
      if (macId) {
        this.hardware_id = macId;
      }
    }
  },
  computed: {
    USE_TIM_INTEGRATION() {
      return this.$store.getters.USE_TIM_INTEGRATION;
    },
    USE_PLAY_ALHAMRA_CARD_MACHINE() {
      let flag = "N";
      if (
        this.$store.getters.USE_CREDIT_CARD_MACHINE_PAYMENT == "Y" &&
        CLIENT_NAME.PLAYCINEMAS == this.CLIENT_SETUP_NAME
      ) {
        flag = "Y";
      }
      return flag;
    },
    USE_EPIX_ASF_CARD_MACHINE() {
      let flag = "N";
      if (
        this.$store.getters.USE_CREDIT_CARD_MACHINE_PAYMENT == "Y" &&
        CLIENT_NAME.EPIX == this.CLIENT_SETUP_NAME
      ) {
        flag = "Y";
      }
      return flag;
    }
  },
  beforeMount() {
    if (this.$cookie.get("ECR_INFO")) {
      let ECR_INFO = JSON.parse(this.$cookie.get("ECR_INFO"));
      Object.keys(ECR_INFO).map(x => {
        this.pos_settings.ECR_SETTINGS[x] = ECR_INFO[x];
      });
    }
    this.DeviceUniqueCode = window.localStorage.getItem("deiviceUniqueCode")
      ? window.localStorage.getItem("deiviceUniqueCode")
      : "";
  },
  mounted() {},
  methods: {
    saveSettings() {
      this.showLoading();
      let payload = JSON.stringify(this.pos_settings.ECR_SETTINGS);
      this.$cookie.set("ECR_INFO", payload);
      let obj = {
        EventBus: EventBus,
        IPADDRESS: this.pos_settings.ECR_SETTINGS.ecr_ip_address,
        PORT: this.pos_settings.ECR_SETTINGS.ecr_port,
        USERID: this.pos_settings.ECR_SETTINGS.ecr_user_id,
        POSID: this.pos_settings.ECR_SETTINGS.pos_id,
        INTEGRATIONID: "367fcd48-f574-4119-960c-d1ebb00f9a97"
      };
      if (
        typeof initTimApi == "function" &&
        this.pos_settings.ECR_SETTINGS.ecr_ip_address &&
        this.pos_settings.ECR_SETTINGS.ecr_port
      ) {
        localStorage.setItem("ECR_INIT_STATUS", true);
        initTimApi(obj);
      } else {
        localStorage.setItem("ECR_INIT_STATUS", false);
      }
      setTimeout(z => {
        this.$bvModal.hide("posSettingsModal");
        this.hideLoading();
      }, 1000);
    },
    saveSettingsV2() {
      if (
        this.pos_settings.ECR_SETTINGS.ecr_no &&
        this.pos_settings.ECR_SETTINGS.ecr_no.length != 2
      ) {
        return this.$toasted.show("Invalid ECR NO. Must be 2 digit.");
      }
      this.showLoading();
      let payload = JSON.stringify(this.pos_settings.ECR_SETTINGS);
      this.$cookie.set("ECR_INFO", payload);
      EventBus.$emit("ECR_INFO_SAVED");
      setTimeout(z => {
        this.$bvModal.hide("posSettingsModal");
        this.hideLoading();
      }, 1000);
    },
    saveSettingsV3() {
      if (
        !this.pos_settings.ECR_SETTINGS.mid ||
        !this.pos_settings.ECR_SETTINGS.tid
      ) {
        return this.$toasted.show("Please Enter Valid MID AND TID.");
      }
      this.showLoading();
      let payload = JSON.stringify(this.pos_settings.ECR_SETTINGS);
      this.$cookie.set("ECR_INFO", payload);
      EventBus.$emit("ECR_INFO_SAVED");
      setTimeout(z => {
        this.$bvModal.hide("posSettingsModal");
        this.hideLoading();
      }, 1000);
    }
  }
};
</script>
<style>
.disbled-section {
  cursor: not-allowed;
  opacity: 0.4;
}

.settings-box {
  font-size: 12px;
  font-weight: bold;
}
#posSettingsModal___BV_modal_content_ {
  width: 135% !important;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/PosSettingsPopup.vue